export const LIKED_TIPS_KEY = "mealpill_liked_tips";

// Liked tips are stored as full objects {type, title, message}.
// Legacy entries are plain "${type}_${title}" strings carrying no message —
// normalize them on read so the rest of the code sees one shape.
export const normalizeLikedTip = (item) =>
  typeof item === "string"
    ? { type: item.split("_")[0], title: item.split("_").slice(1).join("_"), message: null }
    : item;

// Tip identity. Computed from object fields, never parsed back out of a string.
export const tipKeyOf = (tip) => `${tip?.type}_${tip?.title}`;
